import { seriesEsp, seriesEng, seriesId } from './translations/translations_frp_comparacion_espanya_preindustrial.js'
import { translateSeries } from '../lib/translate_series_name.js'

export default class Visualizer {
  series = [];
  charts = [];

  RANGES_DEFAULT = [];
  CHARTS_DEFAULT = [];

  constructor(params) {
    this.charts = params || [];
    this.setDefaults();

    return {
      charts: this.charts.map(x => Object.assign(this.CHARTS_DEFAULT.find(y => y.type == x.type), x)),
      ranges: this.RANGES_DEFAULT,
      endpoints: {
        series: this.series,
        data: {
          build: () => {
            const sql = 'select * from comparacion_internacional_espana ORDER BY year';
            const gobiertoPath = process.env.GOBIERTO_DATA_URL
            const token = process.env.GOBIERTO_DATA_TOKEN
            const query = `?sql=${sql}&token=${token}`;

            return `${gobiertoPath}/api/v1/data/data.json${query}`;
          },
          parse: data => {
            this.series = translateSeries(this.series, seriesEsp, seriesEng, seriesId, null, null, null, null)
            const series = this.series.map(d => ({
              id: d.id,
              name: d.name,
              units: d.units
            }));
            // reorder the return data to be grouped by kind of serie
            const groupBySerie = series.map(set => {
              return data.data.map(d => ({
                serie: set.id,
                time: new Date(d["year"], 0, 1),
                value: parseFloat(d[set.id]),
                name: set.name,
                units: set.units,
                // Add the connector's name to differentiate the tooltips
                idTooltip: "cep"
              }))
            });

            // give a flatted array
            return groupBySerie.flat();
          }
        }
      }
    };
  }

  setDefaults = () => {
    this.series = [
      {
        "id": "pib_spain_dollar_1990gk",
        "name": "PIB per capita España",
        "units": "G-K $1990",
        "group": "G-K $1990"
      },
    {
        "id": "pib_france_dollar_1990gk",
        "name": "PIB per capita Francia",
        "units": "G-K $1990",
        "group": "G-K $1990"
      },
      {
        "id": "pib_uk_dollar_1990gk",
        "name": "PIB per capita Reino Unido",
        "units": "G-K $1990",
        "group": "G-K $1990"
      },
      {
        "id": "pib_usa_dollar_1990gk",
        "name": "PIB per capita Estados Unidos",
        "units": "G-K $1990",
        "group": "G-K $1990"
      },
      {
        "id": "pib_spain_dollar_2021gk",
        "name": "PIB per capita España",
        "units": "G-K $2021",
        "group": "G-K $2021"
      },
      {
        "id": "pib_france_dollar_2021gk",
        "name": "PIB per capita Francia",
        "units": "G-K $2021",
        "group": "G-K $2021"
      },
      {
        "id": "pib_uk_dollar_2021gk",
        "name": "PIB per capita Reino Unido",
        "units": "G-K $2021",
        "group": "G-K $2021"
      },
      {
        "id": "pib_usa_dollar_2021gk",
        "name": "PIB per capita Estados Unidos",
        "units": "G-K $2021",
        "group": "G-K $2021"
      }
    ];

    const range = (start, stop, step = 1) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
    this.RANGES_DEFAULT = range(1277, 2023);

    this.CHARTS_DEFAULT = [{
        type: "Line",
        btnPlaceholder: "Añadir serie",
        xAxisProp: "time",
        yAxisProp: "value",
        aggregationProp: "serie",
        tooltip: this.tooltipCommon,
        language: 'es',
        bspline: false,
        cache: true,
        ticksXAxis: 30,
        tickFormatY: (...args) => {
          const [d, , , d3] = args;

          return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
        }
      },
      {
        type: "Stacked",
        btnPlaceholder: "Añadir serie",
        xAxisProp: "time",
        yAxisProp: "value",
        aggregationProp: "serie",
        tooltip: this.tooltipCommon,
        language: 'es',
        cache: true,
        ticksXAxis: 30,
        tickFormatY: (...args) => {
          const [d, , , d3] = args;

          return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
        }
      }
    ];
  };
  getScale(key, d3) {
    const scales = {
      linear: d3.scaleLinear(),
      log: d3.scaleLog(),
      pow: d3.scalePow()
    };

    if (scales.hasOwnProperty(key)) {
      return scales[key];
    } else {
      return scales[0];
    }
  }
}
